import { Survey } from '../entities/Survey';

export function findReferralSurveys(surveys: Survey[]): Survey[] {
  return surveys.filter((survey) => survey.relationship !== 'candidate');
}
